import axios from "axios"
import {properties} from "../../properties";

export default class CodigoEmpresaService{

    getCodigoEmp(){
        return axios.get(properties.url_api_base+'/codigoEmp').then(res=>res).catch(err=>[]);
    }
}
